import { createFeatureSelector, createSelector } from '@ngrx/store';

import { listTileReducerFactory } from '../../../pillar/dashboard/store/reducers/list-tile.reducerFactory';
import { TileState } from '../../../pillar/dashboard/store/state/TileState';

import { ModuleConfiguration } from '../../customer.module.config';
import { UserListModel } from '../../models/UserListModel';
import { UserModel } from '../../models/UserModel';
import { GroupListModel } from '../../models/GroupListModel';
import { GroupModel } from '../../models/GroupModel';
import { UserState } from '../state/UserState';
import { userReducer } from './user.reducer';
import * as actions from '../../../pillar/dashboard/store/actions/';

export interface CustomerState {
  userState: UserState,
  groupState: TileState<GroupListModel, GroupModel>,
};

let groupStateReducer;
export function groupStateReducerWrapper (state = new TileState<GroupListModel, GroupModel>(), action: actions.Actions<any>): TileState<any, any>  {
  if(!groupStateReducer){
    groupStateReducer = listTileReducerFactory(ModuleConfiguration.moduleName, GroupListModel, GroupModel, new TileState<GroupListModel, GroupModel>());
  }
  return groupStateReducer(state, action);
}

export const reducers = {
  userState: userReducer,
  groupState: groupStateReducerWrapper,
};

export const getSubmissionState = createFeatureSelector(ModuleConfiguration.moduleName);

export const getUsersState = createSelector(getSubmissionState, (s: CustomerState) => s.userState);
export const getUserList = createSelector(getUsersState, (s: UserState) => s.list);
export const getUserListTotalCount = createSelector(getUsersState, (s: UserState) => s.totalCount);
export const getUserListLoading = createSelector(getUsersState, (s: UserState) => s.loading);
export const getUserListErrors = createSelector(getUsersState, (s: UserState) => s.errors);
export const getUserSelection = createSelector(getUsersState, (s: UserState) => s.selected);
export const getUserGroupLookups = createSelector(getUsersState, (s: UserState) => s.groupLookups);
export const getUserNotificationTypes = createSelector(getUsersState, (s: UserState) => s.notificationTypes);
export const getUserAssignedRoles = createSelector(getUsersState, (s: UserState) => s.selected == null ? undefined : s.selected.roles);
export const getUserSubmittingEntities = createSelector(getUsersState, (s: UserState) => s.selectedUserAssociatedSubmittingEntities);
export const getUserCurrentStatus = createSelector(getUsersState, (s: UserState) => s.status);
export const getGlobalLockStatus = createSelector(getUsersState, (s: UserState) => s.globalLockStatus);

export const getGroupsState = createSelector(getSubmissionState, (s: CustomerState) => s.groupState);
export const getGroupList = createSelector(getGroupsState, (s: TileState<GroupListModel, GroupModel>) => s.list);
export const getGroupListTotalCount = createSelector(getGroupsState, (s: TileState<GroupListModel, GroupModel>) => s.totalCount);
export const getGroupListLoading = createSelector(getGroupsState, (s: TileState<GroupListModel, GroupModel>) => s.loading);
export const getGroupListErrors = createSelector(getGroupsState, (s: TileState<GroupListModel, GroupModel>) => s.errors);
export const getGroupSelection = createSelector(getGroupsState, (s: TileState<GroupListModel, GroupModel>) => s.selected);



// WEBPACK FOOTER //
// ./src/app/customer/store/reducers/index.ts